import type { ReactNode } from "react";
import { ChakraList as List, ChakraStack as Stack } from "@airhelp/react-ui-components";

export const WhyChooseList = ({ children }: { children: ReactNode }) => (
  <List>
    <Stack
      direction={{ base: "row", md: "column" }}
      spacing={{ base: 4, md: 8 }}
      overflowX="scroll"
      mx={{ base: -4, md: 0 }}
      scrollSnapType="x mandatory"
      sx={{
        msOverflowStyle: "none",
        "&::-webkit-scrollbar": {
          display: "none",
        },
      }}
    >
      {children}
    </Stack>
  </List>
);
